import {
  ecType,
  ecTypeBackend,
} from "../modules/admin/applications/ec/components/ec.types.ts";
import dayjs from "dayjs";

export const ConvertToEcType = (data: ecTypeBackend): ecType => {
  const barcodeTypeMapping: Record<
    string,
    "CODE39" | "CODE128" | "EAN13" | "QRCODE"
  > = {
    CODE39: "CODE39",
    CODE128: "CODE128",
    EAN13: "EAN13",
    QRCODE: "QRCODE",
  };
  const bindingSourceMapping: Record<string, "both" | "phone" | "email"> = {
    both: "both",
    phone: "phone",
    email: "email",
  };
  const barcodeValueSourceMapping: Record<string, "customer_id" | "email" | "phone" | "member_card_no" | "local_phone" | "ec_customer_id" | "custom_outer_code_1"> = {
    customer_id: "customer_id",
    email: "email",
    phone: "phone",
    member_card_no: "member_card_no",
    local_phone: "local_phone",
    ec_customer_id: "ec_customer_id",
    custom_outer_code_1: "custom_outer_code_1",
  };

  return {
    module_token: data.card_module_token,
    module_token_expired_at: new Date(data.card_module_token_expired_at),
    brand_name: data.card_brand_name || "",
    sms_brand_name: data.sms_brand_name || "",
    logo_url: data.card_logo || "",
    logo: [],
    member_card_url: data.card_member_card_url || "",
    foreground_color: data.card_foreground_color || "#4586F0",
    background_color: data.card_background_color || "#f5f7fa",
    is_enabled_barcode: data.card_is_enabled_barcode || false,
    barcode_type: barcodeTypeMapping[data.card_barcode_type] || "CODE128",
    barcode_value_source: barcodeValueSourceMapping[data.card_barcode_value_source] || "customer_id",
    is_enabled_member_benefits: data.card_is_enabled_member_benefits || false,
    member_benefits_url: data.card_member_benefits_url || "",
    is_enabled_faq: data.card_is_enabled_faq || false,
    faq_url: data.card_faq_url || "",
    order_url: data.card_order_url || "",
    show_referrer_info_box: data.card_show_referrer_info_box || false,
    card_binding_source:
      bindingSourceMapping[data.card_binding_source] || "both",
    is_enabled_annual_consumption: data.card_is_enabled_annual_consumption ?? true,
    is_enabled_order: data.card_is_enabled_order ?? true,
    is_enabled_otp_methods_switch: data.enable_otp_methods_switch || false,
    is_enabled_show_order_after_date: data.card_is_enabled_show_order_after_date || false,
    show_order_after_date: data.card_show_order_after_date ? dayjs(data.card_show_order_after_date) : null,
    show_member_level: data.card_show_member_level ?? true,
    enable_member_level_name: data.card_enable_member_level_name ?? false,
    member_level_name_mapping: data.card_member_level_name_mapping ?? {},
    enable_custom_credits_name: data.card_enable_custom_credits_name ?? false,
    custom_credits_name_mapping: data.card_custom_credits_name_mapping ?? {},
  };
};

export const ConvertToBackendType = (data: ecType): ecTypeBackend => {

  const filteredMemberLevelMapping: Record<string, string> = {};
  if (data.member_level_name_mapping) {
    Object.entries(data.member_level_name_mapping).forEach(([key, value]) => {
      // Only include keys with non-empty values after trimming
      if (value && value.trim()) {
        filteredMemberLevelMapping[String(key)] = value.trim();
      }
    });
  }

  return {
    card_module_token: data.module_token,
    card_module_token_expired_at: data.module_token_expired_at,
    card_brand_name: data.brand_name,
    // harmony rejects a blank value; omitting the key keeps the stored one.
    sms_brand_name: data.sms_brand_name?.trim() || undefined,
    card_logo: data.logo_url,
    card_member_card_url: data.member_card_url,
    card_foreground_color: data.foreground_color,
    card_background_color: data.background_color,
    card_is_enabled_barcode: data.is_enabled_barcode,
    card_barcode_type: data.barcode_type,
    card_barcode_value_source: data.barcode_value_source,
    card_is_enabled_member_benefits: data.is_enabled_member_benefits,
    card_member_benefits_url: data.member_benefits_url,
    card_is_enabled_faq: data.is_enabled_faq,
    card_faq_url: data.faq_url,
    card_order_url: data.order_url,
    card_show_referrer_info_box: data.show_referrer_info_box,
    card_binding_source: data.card_binding_source,
    card_is_enabled_annual_consumption: data.is_enabled_annual_consumption,
    card_is_enabled_order: data.is_enabled_order,
    enable_otp_methods_switch: data.is_enabled_otp_methods_switch,
    card_is_enabled_show_order_after_date: data.is_enabled_show_order_after_date,
    card_show_order_after_date: data.show_order_after_date,
    card_show_member_level: data.show_member_level,
    card_enable_member_level_name: data.enable_member_level_name,
    card_member_level_name_mapping: filteredMemberLevelMapping,
    card_enable_custom_credits_name: data.enable_custom_credits_name,
    card_custom_credits_name_mapping: data.custom_credits_name_mapping,
  };
};
